import Box from "@material-ui/core/Box";
import React, { useEffect, useState } from "react";
import { useLocalStorage } from "src/utils/use-local-storage";
import CustomTabs from "./custom-tabs";
import InputCheckBox from "./input-checkbox";
import TabPanel from "./tab-panel";
import { ArrowLeftIcon, ArrowRightIcon } from "./icons-svg";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { Select } from "./select";
import store from "src/store";
import Tooltip from "./tooltip";

export default function TaskList(props) {
  const [showTaskTabs, setShowTaskTabs] = useLocalStorage('showTaskTabs', true);

  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [filterValueList, setFilterValueList] = useState([]);
  const [selectedFilterValue, setSelectedFilterValue] = useState('');
  const [selectedTaskList, setSelectedTaskList] = useState([]);

  const getTabs = () => {
    let tabs = [];
    tabs = props.taskObj.categories.map((item, idx) => {
      return {
        label: item + ' (' + taskCountForCategoryList(item, 'completed') + '/' + taskCountForCategoryList(item, 'total') + ')',
        disabled: false
      }
    });
    setTabs(tabs);
  }

  useEffect(() => {
    getTabs();
    getFilterValueLists(props.taskObj.categories[0]);
  }, []);

  useEffect(() => {
    getTabs();
  }, [props.completedTasks]);

  const taskCountForCategoryList = (category, type) => {
    if (type == 'total') {
      return props.taskObj.tasks.filter((task) => (task.category == category)).length;
    } else if (type == 'completed') {
      return props.taskObj.tasks.filter((task) => (task.category == category && props.completedTasks[task.id])).length;
    } else {
      return 0;
    }
  }

  const getFilterValueLists = (category) => {
    let filterValueList = _.uniq(
      props.taskObj.tasks.filter((item) => (item.category == category && item.filterValue)).map((item) => (item.filterValue))
    );

    setSelectedFilterValue(filterValueList[0]);
    getTaskList(category, filterValueList[0]);
    setFilterValueList(filterValueList)
  }

  const getTaskList = (category, filterValue) => {
    let taskList = props.taskObj.tasks.filter((item) => (item.category == category && item.filterValue == filterValue));
    setSelectedTaskList(taskList)
  }

  const onTabChange = (value) => {
    getFilterValueLists(props.taskObj.categories[value]);
    setActiveTab(value);
  }

  const onFilterValueChange = (value) => {
    getTaskList(props.taskObj.categories[activeTab], value);
    setSelectedFilterValue(value)
  }

  const getFilterValueCount = (filterValue, type) => {
    if (type == 'total') {
      return props.taskObj.tasks.filter((task) => (task.category == props.taskObj.categories[activeTab] && task.filterValue == filterValue)).length;
    } else if (type == 'completed') {
      return props.taskObj.tasks.filter((task) => (task.category == props.taskObj.categories[activeTab] && task.filterValue == filterValue && props.completedTasks[task.id])).length;
    } else {
      return 0;
    }
  }

  return (
    <>
      <Box
        style={{ flexGrow: 1, display: 'flex', height: '90vh' }}
      >
        <CustomTabs
          tabs={tabs}
          value={activeTab}
          onTabChange={(event, value) => onTabChange(value)}
          orientation="vertical"
          showTabs={showTaskTabs}
        >
          <div css={`
              display: flex;
              justify-content: right;`
          }>
            {
              showTaskTabs ?
                <span css={`
                      color:#799fd4;
                      cursor: pointer;
                      text-decoration-line: underline;
                  `}
                  onClick={() => { setShowTaskTabs(false) }}>{ArrowLeftIcon}</span>
                :
                <span css={`
                      color:#799fd4;
                      cursor: pointer;
                      text-decoration-line: underline;
                  `}
                  onClick={() => { setShowTaskTabs(true) }}>{ArrowRightIcon}</span>
            }
          </div>
          <div style={{ width: "80%", overflowY: 'auto' }}>
            {
              tabs.length ?
                tabs.map((item, id) => {
                  return (
                    <TabPanel value={activeTab} index={id} key={id}>
                      {filterValueList?.length > 0 && <Select
                        label=""
                        value={selectedFilterValue}
                        onChange={e => {
                          onFilterValueChange(e.target.value)
                        }}
                      >
                        {
                          filterValueList.map((item, idx) => (
                            <option key={idx} value={item}>
                              {item + ' (' + getFilterValueCount(item, 'completed') + '/' + getFilterValueCount(item, 'total') + ')'}
                            </option>
                          ))
                        }
                      </Select>}

                      {
                        selectedTaskList.length ?
                          selectedTaskList.map((task, index) => (
                            <div
                              css={`
                              display: flex;
                              align-items: center;
                              justify-content: flex-start;
                            `}
                              key={index}>
                              <InputCheckBox
                                checked={props.completedTasks[task.id]}
                                onChange={(value) => props.setCompletedTask(task.id, value)}
                              />
                              <div>{task.title}</div>
                              {
                                task.goToSourceLocation &&
                                <div
                                  css={`
                                  display: flex;
                                  align-items: center;
                                  justify-content: flex-start;
                                  color:#799fd4;
                                  cursor: pointer;
                                  padding-left: 5px;
                                `}>
                                  <div onClick={() => {props.setCursorPositionInsimplifiedFromSourceMap(task.goToSourceLocation)}}>{store.getLineContentFromSourceMap(props.simplifiedData, task.goToSourceLocation)}</div>
                                  <div
                                    css={`
                                    padding-left: 5px;
                                  `}>
                                    <Tooltip
                                      tip={'Click to redirect to the source map.'}
                                    ><InfoOutlinedIcon
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '20px'
                                      }}/>
                                    </Tooltip>
                                  </div>
                                </div>
                              }
                            </div>
                          )) : null
                      }
                    </TabPanel>
                  )
                }) : null
            }
          </div>
        </CustomTabs>
      </Box>
    </>
  )
}